module.exports = __webpack_public_path__ + "static/media/user.e4e01910.svg";